<template>
  <dialog :open="isOpen" class="default-dialog" @click="closeModal">
    <div class="dialog-content text-center p-0 overflow-hidden" @click.stop>
      <div class="banner-top d-flex align-items-center justify-content-center p-4">
        <div class="icon-pulse">
           <i class="fas fa-shield-alt text-white"></i>
        </div>
      </div>

      <div class="p-4 pt-5">
        <h3 class="font-weight-bolder text-dark mb-3">Segurança Opcional Ativada! 🔐</h3>
        
        <p class="text-secondary mb-4 px-2">
          Agora você tem total controle sobre a segurança da sua conta. 
          A verificação de dois fatores via WhatsApp tornou-se <strong>opcional</strong>.
        </p>

        <div class="feature-list mb-4 text-start px-3">
          <div class="feature-item d-flex align-items-start mb-3">
             <i class="material-icons text-success me-2">check_circle</i>
             <span class="text-sm">Ative ou desative quando quiser.</span>
          </div>
          <div class="feature-item d-flex align-items-start mb-3">
             <i class="material-icons text-success me-2">check_circle</i>
             <span class="text-sm">Mais agilidade no acesso diário se você preferir.</span>
          </div>
          <div class="feature-item d-flex align-items-start">
             <i class="material-icons text-success me-2">check_circle</i>
             <span class="text-sm">Proteção garantida via WhatsApp para sua segurança.</span>
          </div>
        </div>

        <p class="text-xs text-secondary mt-2 mb-4">
          Deseja configurar sua preferência de segurança agora?
        </p>

        <div class="d-flex flex-column gap-2 mb-2">
          <button
            @click="goToSettings"
            class="btn btn-primary-gradient mb-0"
          >
            Configurar Agora
          </button>
          <button @click="closeModal" class="btn btn-outline-secondary mb-0">
            Entendi, depois eu vejo
          </button>
        </div>
      </div>
    </div>
  </dialog>
</template>

<script>
export default {
  name: "TwoFAAnnouncementModal",
  props: {
    isOpen: {
      type: Boolean,
      required: true,
    },
  },
  methods: {
    closeModal() {
      this.$emit("confirm");
    },
    goToSettings() {
      this.$emit("settings");
    },
  },
};
</script>

<style scoped lang="scss">
.default-dialog {
  border: none;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 999999;
  background: none;
  backdrop-filter: blur(8px);
  background-color: rgba(0, 0, 0, 0.5);
  width: 100vw;
  height: 100vh;
}

dialog {
  pointer-events: none;
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.4s ease, visibility 0.4s ease, transform 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  display: flex;
  flex-direction: column;
  align-items: center;
}

dialog[open] {
  opacity: 1;
  visibility: visible;
  pointer-events: auto;
}

.dialog-content {
  width: 450px;
  max-width: 95%;
  background: white;
  border-radius: 24px;
  z-index: 2;
  transform: translateY(20px);
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.4);
}

dialog[open] .dialog-content {
  transform: translateY(0);
}

.banner-top {
  background: linear-gradient(135deg, #661cb0 0%, #a64bf4 100%);
  height: 120px;
  width: 100%;
  position: relative;
}

.icon-pulse {
  background: rgba(255, 255, 255, 0.2);
  width: 80px;
  height: 80px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 40px;
  animation: pulse 2s infinite;
  
  i {
    filter: drop-shadow(0 4px 6px rgba(0,0,0,0.2));
  }
}

@keyframes pulse {
  0% { transform: scale(0.95); box-shadow: 0 0 0 0 rgba(255, 255, 255, 0.7); }
  70% { transform: scale(1); box-shadow: 0 0 0 15px rgba(255, 255, 255, 0); }
  100% { transform: scale(0.95); box-shadow: 0 0 0 0 rgba(255, 255, 255, 0); }
}

.btn-primary-gradient {
  background: linear-gradient(135deg, #661cb0 0%, #a64bf4 100%);
  color: white;
  border: none;
  font-weight: 700;
  padding: 14px;
  border-radius: 12px;
  transition: all 0.3s ease;
  
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 20px rgba(102, 28, 176, 0.4);
  }
}

.feature-item i {
  font-size: 20px;
}

.text-truncate-2 {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
</style>
